import type { TFunction } from 'i18next';

import type { User } from '@/types/user';

export interface ProfileField {
  key: string;
  label: string;
  isSet: boolean;
  required: boolean;
}

export function buildProfileFields(
  t: TFunction,
  user: User | null
): ProfileField[] {
  return [
    {
      key: 'firstName',
      label: t('profileCompletion.fields.firstName'),
      isSet: !!user?.firstName?.trim(),
      required: true,
    },
    {
      key: 'lastName',
      label: t('profileCompletion.fields.lastName'),
      isSet: !!user?.lastName?.trim(),
      required: true,
    },
    {
      key: 'phone',
      label: t('profileCompletion.fields.phone'),
      isSet: !!user?.phone?.trim(),
      required: false,
    },
    {
      key: 'position',
      label: t('profileCompletion.fields.position'),
      isSet: !!user?.position?.trim(),
      required: false,
    },
  ];
}
